import { type ReactElement } from 'react'
import { Box, Typography } from '@mui/material'

import CardContainer from '@/components/dashboard/CardContainer'

const PendingPayment = (): ReactElement => {
  return (
    <CardContainer title={'Pending Payment'}>
      <Box px={'16px'} flex={1} sx={{ width: '100%' }}>
        <Typography
          sx={{
            color: 'var(--Ebony-Clay-400, #AAB3CF)',
            fontSize: '14px',
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: '160%',
          }}
          variant="body1"
          component="h2"
        >
          No pending payments at the moment.
        </Typography>
        <Box mt={'8px'}>
          <Typography
            display="inline"
            sx={{
              color: 'var(--Ebony-Clay-400, #AAB3CF)',
              fontSize: '14px',
              fontWeight: '400',
              fontStyle: 'normal',
              lineHeight: '160%',
            }}
            variant="body1"
            component="h2"
          >
            You&apos;re currently on the{' '}
            <span
              style={{
                color: '#5D5DFF',
              }}
            >
              Free Plan
            </span>{' '}
            - kudos!
            {/* Ready to elevate your experience? Upgrade today and unlock even more benefits.{' '} */}
          </Typography>
        </Box>
        {/* <Typography
          sx={{
            color: 'var(--Emerald-600, #22C55E)',
            fontSize: '14px',
            fontWeight: 'bold',
            fontStyle: 'normal',
            lineHeight: '160%',
          }}
          variant="body1"
        >
          {' '}
          <Link
            href="/"
            sx={{
              '&:hover': {
                color: 'var(--Emerald-500, #4ADE80)',
              },
            }}
          >
            Explore more plans now!
          </Link>
        </Typography> */}
      </Box>
    </CardContainer>
  )
}

export default PendingPayment
